import { Stack, styled } from "@mui/material";
import { ArrowRight24Px } from "@qubit/autoparts";

import useFlag from "~/config/flags";

type PulsingArrowProps = {
  delay: number;
  enableColorChanges: boolean;
};

const PulsingArrow = styled(ArrowRight24Px, {
  shouldForwardProp: (prop) => prop !== "delay" && prop !== "enableColorChanges"
})<PulsingArrowProps>(({ theme, delay, enableColorChanges }) => ({
  "@keyframes pulse": {
    from: {
      opacity: 0.1
    },
    to: { opacity: 1 }
  },
  animation: "pulse 800ms infinite steps(3, jump-none)",
  animationDirection: "alternate",
  animationDelay: `${delay}ms`,
  fill: enableColorChanges
    ? theme.palette.autostoreDesignSystem.icon.onStandard.statusInformative
    : theme.palette.primary.main,
  height: "40px",
  width: "20px"
}));

export const PulsingArrows = () => {
  const { enableColorChanges } = useFlag();

  return (
    <Stack
      direction="row"
      alignItems="center"
      m={2}
      aria-label="pulsing-arrows"
    >
      <PulsingArrow delay={0} enableColorChanges={enableColorChanges} />
      <PulsingArrow delay={500} enableColorChanges={enableColorChanges} />
      <PulsingArrow delay={1000} enableColorChanges={enableColorChanges} />
    </Stack>
  );
};
